<template>
  <div
    class="help-bubble triangle-right right"
    style="display: block;">
    <div class="shadow6">
      <div class="media">
        <div class="media-left">
          <img
            v-if="img"
            class="media-object"
            src="./../assets/bullet.png">
        </div>
        <div class="media-body">
          <div class="col-md-12">
            <span class="media-text" v-html="message" />
          </div>
          <div
            v-if="button"
            class="row">
            <div class="col-md-10"/>
            <div class="col-md-2">
              <b-button
                size="sm"
                class="downloadButton"
                v-b-modal.donate>
                {{ buttonItems.label }}
              </b-button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
      default: null,
    },
    img: {
      type: Boolean,
      default: true,
    },
    button: {
      type: Boolean,
      default: false,
      required: false,
    },
    buttonItems: {
      type: Object,
      default: null,
      required: false,
    },
  },
};
</script>
<style>
.media-body {
  text-align: left;
  font-size: 13px;
  padding-left: 0!important;
}
.triangle-right {
  margin-right: 0px!important;
  margin-bottom: 2em!important;
  margin-left: 1em!important;
}

span.media-text a {
  color: #fff;
  font-weight: 500;
}
span.media-text a:hover {
text-decoration: underline;
}
</style>
